// extracted by mini-css-extract-plugin
module.exports = {"large":"IconBedRoom_large__fCMWd"};